import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "20",
  fill: "none",
  viewBox: "0 0 24 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6 0h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m13.704 17.704A2.4 2.4 0 0 0 20.41 16V4A2.41 2.41 0 0 0 18 1.59H6A2.41 2.41 0 0 0 3.59 4v12A2.41 2.41 0 0 0 6 18.41h12a2.4 2.4 0 0 0 1.704-.706",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M16 9.25h-3.25V6a.75.75 0 0 0-1.5 0v3.25H8a.75.75 0 0 0 0 1.5h3.25V14a.75.75 0 0 0 1.5 0v-3.25H16a.75.75 0 0 0 0-1.5"
    }, null, -1)
  ]))]))
}
export default { render: render }